const appDisplayNames = {
  echo: 'Echo',
  joychat: 'Joychat',
  joyu: 'Joyu',
  kiko: 'Kiko',
  vava: 'Vava',
  vibeo: 'Vibeo',
  whonow: 'Whonow',
}

export default {
  methods: {
    setDocMeta() {
      const faviconEl = document.querySelector('link[rel=icon]')
      if (faviconEl) {
        faviconEl.href = this.appIconSrc
      }
      document.title = (appDisplayNames[this._pagePackage] || 'App') + ' - Download'
    },
  },
}
